'use client';
var ColumnGroup = function ColumnGroup() {};
ColumnGroup.displayName = 'ColumnGroup';

export { ColumnGroup };
